import script from "./SpecialProject.vue?vue&type=script&setup=true&lang=js"
export * from "./SpecialProject.vue?vue&type=script&setup=true&lang=js"

import "./SpecialProject.vue?vue&type=style&index=0&id=366481f9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-366481f9"]])

export default __exports__